// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2ywix","inputWrap":"styles_inputWrap__3UIsU","input":"styles_input__1g5UU"};